import { render, staticRenderFns } from "./BaseCardMc.vue?vue&type=template&id=d0eab858&scoped=true&"
import script from "./BaseCardMc.vue?vue&type=script&lang=js&"
export * from "./BaseCardMc.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardMc.vue?vue&type=style&index=0&id=d0eab858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0eab858",
  null
  
)

export default component.exports